import { FormControl, TextField } from "@mui/material";
import { Field, useFormikContext } from "formik";
import { styled } from "@mui/material/styles";

const TextFieldStyled = styled(TextField)(() => ({
  "&[readonly] > div.MuiInputBase-root": {
    backgroundColor: "#f4f4f4",
  },
}));

const Textarea = (props) => {
  const {
    name,
    label,
    helperText,
    placeholder,
    size = "small",
    fullWidth = true,
    variant = "outlined",
    required = false,
    multiline,
    rows,
    maxLength,
    readOnly = false,
  } = props;
  const { handleBlur } = useFormikContext();

  return (
    <Field as="Select" name={name}>
      {({ field }) => (
        <FormControl fullWidth={fullWidth}>
          <TextFieldStyled
            {...props}
            {...field}
            name={name}
            autoComplete="off"
            fullWidth={fullWidth}
            size={size}
            variant={variant}
            required={required}
            multiline={multiline}
            rows={rows}
            placeholder={placeholder}
            helperText={helperText}
            label={label}
            inputProps={{ maxLength, readOnly }}
            onBlur={(event) => {
              handleBlur(event);
            }}
          />
        </FormControl>
      )}
    </Field>
  );
};

export default Textarea;
